<template>
  <v-container fluid class="pt-1 pa-0">
    <v-row dense>
      <v-col
        v-if="$vuetify.breakpoint.smAndUp"
        cols="12"
        sm="4"
        xl="3"
        class="d-flex flex-column"
        style="gap: 12px"
      >
        <slot name="left">
          <span>Default Left Section</span>
        </slot>
      </v-col>
      <v-col cols="12" sm="8" xl="9">
        <slot name="main">
          <span>Default Main Section</span>
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TwoColumnLayout",
};
</script>
